import {LinksTabs} from './LinksTabs'
import {usePopularLinksTab, useRelatedLinksTab} from './useLinksTabs'

/**
 * Interlinking block of the SEO SRP footer
 */
export const SrpLinks = () => (
  <LinksTabs tabs={[usePopularLinksTab(), useRelatedLinksTab()]} />
)
